import moment from "moment";
import { Track } from 'src/app/interfaces/api/track';
import { createExtendedMesh } from 'src/app/interfaces/shared/extendMesh';
import * as Tools from '../../shared/threeDTools';

export class ColliderShape {
    geometryType: string;
    geometry: any;
    vertices: any[] = [];
    trackerName: string;
    trackerId: string;
    lookAtTracker: any;
    lookAtType: any;
    animation: any;
    position: any;
    rotation: any;
    posOffset: any;
    lastPosition: any;
    center: any;
    offset: any;
    margin: any;
    fullHeight: any;
    fromTracker: any;
    scale: any;
    size: any;
    offsetAxis: any;
    offsetAngle: any;
    // mesh: ExtendedMesh = createExtendedMesh();
    mesh: THREE.Mesh = createExtendedMesh();
    events: any;
    trackerOnTop: boolean;
    model: any;
    lastTrack: any;
    extrapolationCoef: number = 4;
    hookMargin: number = 0;
    craneCollider: ColliderShape;
    crane: any;
    radialSegments: number = 16;
    heightSegments: number = 1;
    topradius: number = 1;
    bottomradius: number = 1;
    height: number = 1;
    width: number = 1;
    length: number = 1;
    radius: number = 1;
    visible: boolean = true;

    constructor(options: any) {
        this.model = options.model;
        this.geometryType = options.geometry;
        this.trackerName = options.trackerName;
        this.trackerId = options.trackerId;
        this.lookAtTracker = options.lookAtTracker;
        this.lookAtType = options.lookAtType;
        this.animation = options.animation;
        this.position = options.position;
        this.rotation = options.rotation;
        this.posOffset = options.posOffset || { x: 0, y: 0, z: 0 };
        this.lastPosition = { x: 0, y: 0, z: 0 };
        this.center = options.center;
        this.offset = options.offset;
        this.margin = options.margin;
        this.fullHeight = options.fullHeight;
        this.trackerOnTop = options.trackerOnTop;
        this.fromTracker = options.fromTracker;
        this.extrapolationCoef = options.extrapolationCoef;
        this.hookMargin = options.hookMargin || 0;
        this.craneCollider = options.craneCollider;
        this.scale = parseFloat(options.scale) || 1;
        this.crane = options.crane;

        this.size = {
            x: parseFloat(options.length || 1),
            y: parseFloat(options.width || 1),
            z: parseFloat(options.height || 1),
            width: parseFloat(options.width || 1),
            length: parseFloat(options.length || 1),
            height: parseFloat(options.height || 1),
            topradius: parseFloat(options.topradius || 1),
            bottomradius: parseFloat(options.bottomradius || 1),
            radius: parseFloat(options.radius || 1)
        }

        if (this.trackerOnTop && this.size.height) this.posOffset.z = this.size.height * -1 * this.scale;
        this.offsetAxis = options.offsetAxis;
        this.offsetAngle = options.offsetAngle;

        if ((this.position.x == undefined || this.position.y == undefined) && this.position.lat && this.position.lon) {
            let { x, y, z } = Tools.applyTransform2(this.position, this.model.origin, this.model.offset);
            this.position.x = x;
            this.position.y = y;
        }

        this.createMesh(new THREE.Geometry(), options.material);
    }

    createMesh(geometry: THREE.Geometry, material: THREE.Material) {
        try {

            if (!material) material = new THREE.MeshPhongMaterial({
                color: 0x000000,
                depthWrite: false
            });

            switch (this.geometryType) {
                case 'Cylinder':
                case 'Crane hook':
                    geometry = new THREE.CylinderGeometry(this.size.topradius, this.size.bottomradius, this.size.height, this.radialSegments, this.heightSegments);

                    // Apply rotation
                    let matrix = new THREE.Matrix4();
                    matrix.makeRotationX(Math.PI * .5);
                    geometry.applyMatrix(matrix);

                    // Apply translation to move the geometry up by half its height
                    matrix = new THREE.Matrix4();
                    geometry.applyMatrix(matrix);
                    break;

                case 'Box':
                case 'Axis':
                case 'Jib':
                    geometry = new THREE.BoxGeometry(this.size.length, this.size.width, this.size.height, 4, 4, 4);
                    break;

                case 'Sphere':
                    geometry = new THREE.SphereGeometry(this.size.radius, 32);
                    break;

                case 'Crane':
                    geometry = new THREE.SphereGeometry(this.size.radius, 32);
                    break;

                default:
                    geometry = new THREE.SphereGeometry(1, 32);
                    break;
            }

            let mesh, parent;

            mesh = new THREE.Mesh(geometry, material);

            if (this.offset) {
                let matrix = new THREE.Matrix4();
                matrix.makeTranslation(this.offset.x || 0, this.offset.y || 0, this.offset.z || 0);
                geometry.applyMatrix(matrix);
            }

            if (this.lookAtTracker) {
                // let buffer = new THREE.BufferGeometry().fromGeometry(new THREE.BoxGeometry(1, 1, 1, 4, 4, 4))
                parent = createExtendedMesh(new THREE.BoxGeometry(1, 1, 1, 4, 4, 4), material);
                mesh.name = 'collider_child_' + this.trackerName;

                parent.add(mesh)
                this.mesh = parent;

            } else {

                this.mesh = mesh;
            }

            if (this.position)
                this.mesh.position.copy(new THREE.Vector3(this.position.x + this.posOffset.x, this.position.y + this.posOffset.y, this.position.z + this.posOffset.z));

            // if (this.rotation)
            //     this.mesh.rotation.set(this.rotation.x, this.rotation.y, this.rotation.z);

            this.geometry = { ...this.mesh.geometry };
            this.mesh.geometry.computeBoundingBox();

            // if (this.mesh.geometry instanceof THREE.BufferGeometry) {
            //     this.vertices = Tools.getVerticesFromGeometry(this.mesh.geometry )
            // }

            this.vertices = (this.mesh.geometry as THREE.Geometry).vertices.map((v: { clone: () => any; }) => v.clone())

            this.mesh.name = 'collider_' + this.trackerName;
            this.mesh.scale.set(this.scale, this.scale, this.scale);
            this.mesh.updateMatrix();
        } catch (e) {
            console.error(e)
        }

    }


    lookAt(track: Track, up: string): number {
        let vector, angle;

        //get the normalized vector of the target
        let target = new THREE.Vector3(track.x, track.y, track.z);
        vector = target.sub(this.mesh.position);
        if (up == "z") {
            //calculate angle
            angle = Math.atan2(vector.y, vector.x);
        } else if (up == "y") {
            angle = Math.atan2(vector.z * -1, vector.x);

        } else {
            angle = Math.atan2(vector.z, vector.y);

        }

        return angle;
    }

    angleTo(track: Track, up: THREE.Vector3) {
        let target = new THREE.Vector3(track.x, track.y, track.z);
        let vector = target.sub(this.mesh.position);
        let _up = up || new THREE.Vector3(0, 0, -1);

        return (Math.PI * .5) - _up.angleTo(vector);
    }

    alignToDirection(track: any) {
        this.mesh.lookAt(track)
        this.mesh.rotateY(Math.PI * -.5)
    }

    getSpeed(track: Track) {
        let timeDiff = moment(track.createdDate).diff(this.lastTrack.createdDate, "seconds", true);

        let target = new THREE.Vector3(track.x, track.y, track.z);
        let dist = target.distanceTo(this.mesh.position);

        if (!timeDiff || dist < .5) return 0;

        let speed = (dist / timeDiff) / this.scale;
        return speed;
    }

    getStopDistance(speed: number) {
        return (speed * 3.6 / this.extrapolationCoef) ** 2;
    }

    transformWithSpeed(track: Track) {
        let speed = this.getSpeed(track)
        let stopDist = this.getStopDistance(speed);

        if (speed)
            this.alignToDirection(track);
        let geometry: THREE.Geometry = this.mesh.geometry as THREE.Geometry;
        let center = geometry.boundingBox.getCenter();

        this.vertices.forEach((v, i) => {
            if (v.x > center.x) {
                geometry.vertices[i]!.x = v.x + stopDist;
            }
        })

        geometry.verticesNeedUpdate = true;

        // this.mesh.geometry.computeBoundingBox();
        // const bbox = this.mesh.geometry.boundingBox!; // THREE.Box3

        // const center = new THREE.Vector3();
        // bbox.getCenter(center);

        // const geometry = this.mesh.geometry as THREE.BufferGeometry;
        // const pos = geometry.getAttribute('position') as THREE.BufferAttribute;

        // this.vertices.forEach((v, i) => {
        //     if (v.x > center.x) {
        //         const y = pos.getY(i);
        //         const z = pos.getZ(i);
        //         pos.setXYZ(i, v.x + stopDist, y, z);
        //     }
        // })

        // pos.needsUpdate = true;
        // geometry.computeBoundingBox();
        // geometry.computeVertexNormals();
    }

    transformCraneHook() {
        if (!this.craneCollider) return


        this.mesh.geometry.computeBoundingBox();
        const bbox = this.mesh.geometry.boundingBox!; // THREE.Box3

        //getting the geometry delta z
        let bBoxMax = bbox.max;
        let bBoxMin = bbox.min;

        //here we get the height between jib and hook + margin to dispatch vertices along the z axis
        let maxZ = this.craneCollider.mesh.position.z + (this.craneCollider.crane.height * this.scale);
        let minZ = this.mesh.position.z - (this.hookMargin * this.scale);

        //find the height for mobile crane
        if (this.craneCollider.crane.type == "mobile" || this.craneCollider.crane.type == "luffing") {
            let x = this.mesh.position.x - this.craneCollider.mesh.position.x;
            let y = this.mesh.position.y - this.craneCollider.mesh.position.y;
            let distFromBase = Math.sqrt(x ** 2 + y ** 2);
            let totalHeight = Math.sqrt(Math.abs((this.craneCollider.crane.jibLength * this.scale) ** 2 - distFromBase ** 2));

            if (this.craneCollider.crane.type == "luffing") {
                totalHeight += this.craneCollider.crane.height * this.scale;
            }

            maxZ = this.craneCollider.mesh.position.z + totalHeight;
        }

        let diff = maxZ - minZ;
        let geoDiff = bBoxMax.z - bBoxMin.z;
        let diffRatio = diff / geoDiff;
        diffRatio /= this.scale;

        // const geometry = this.mesh.geometry as THREE.BufferGeometry;
        // const pos = geometry.getAttribute('position') as THREE.BufferAttribute;

        // //converting the z of vertices within the geometry
        // this.vertices.forEach((v, i) => {
        //     let newZ = (v.z - bBoxMin.z) * diffRatio;
        //     const y = pos.getY(i);
        //     const x = pos.getX(i);
        //     pos.setXYZ(i, x, y, newZ - this.hookMargin);
        // })

        // pos.needsUpdate = true;
        // geometry.computeBoundingBox();
        // geometry.computeVertexNormals();

    }

    update(track: Track, lookAtTrack: Track, isJibTracker: boolean) {
        if (track) {
            if (this.geometryType == "Box") {
                if (this.lastTrack) {
                    this.transformWithSpeed(track);
                }

                this.lastTrack = track;
            }

            this.mesh.position.set(track.x + this.posOffset.x, track.y + this.posOffset.y, track.z + this.posOffset.z);
        }

        if (lookAtTrack) {
            let newLength, newHeight, lengthScale = 1, heightScale = 1;

            if (this.fromTracker || (this.fullHeight && this.lookAtType !== "ROTATE_2D_CONSTRAINT")) {
                let xDist = lookAtTrack.x - this.mesh.position.x;
                let yDist = lookAtTrack.y - this.mesh.position.y;
                let zDist = lookAtTrack.z - this.mesh.position.z;

                if (this.lookAtType == "ROTATE_3D") {
                    newLength = Math.abs(Math.sqrt(xDist ** 2 + yDist ** 2 + zDist ** 2));
                } else if (this.lookAtType == "ROTATE_2D") {
                    newLength = Math.abs(Math.sqrt(xDist ** 2 + yDist ** 2));
                }

                lengthScale = (newLength + this.margin) / this.size.length;
            }

            if (this.fullHeight && this.lookAtType !== "ROTATE_2D_CONSTRAINT") {
                if (this.fromTracker) {
                    newHeight = (lookAtTrack.z - this.mesh.position.z) / this.scale;
                } else {
                    let xDist = (lookAtTrack.x - this.mesh.position.x) / this.scale;
                    let yDist = (lookAtTrack.y - this.mesh.position.y) / this.scale;
                    let dist = Math.abs(Math.sqrt(xDist ** 2 + yDist ** 2));

                    if (dist > this.size.length) dist = this.size.length;

                    newHeight = Math.abs(Math.sqrt(this.size.length ** 2 - dist ** 2)) + this.size.height;
                }

                heightScale = newHeight / this.size.height;
            }

            if (this.mesh.children && this.mesh.children.length)
                this.mesh.children[0]?.scale.set(lengthScale, 1, heightScale);

            if (isJibTracker) {
                if (this.mesh.children && this.mesh.children.length) {
                    this.mesh.children[0]?.scale.set(lengthScale / this.scale, 1, heightScale);
                }
            }

            if (this.lookAtType == "ROTATE_3D") {
                let angleYRadians = this.angleTo(lookAtTrack, new THREE.Vector3(0, 0, -1));

                if (this.mesh.children && this.mesh.children.length)
                    this.mesh.children[0]!.rotation.y = angleYRadians;

                let angleZRadians = this.lookAt(lookAtTrack, "z");
                this.mesh.rotation.z = angleZRadians;

                // let angleYRadians = this.angleTo(lookAtTrack, new THREE.Vector3(0, 0, -1));
                // let rotation: THREE.Euler = this.mesh.children[0]!.rotation
                // if (rotation) {
                //     rotation.set(rotation.x, angleYRadians, rotation.z);
                // }

                // let angleZRadians = this.lookAt(lookAtTrack, "z");
                // rotation.set(rotation.x, rotation.y, angleZRadians);
                // this.mesh.rotation.z = angleZRadians;
            } else if (this.lookAtType == "ROTATE_2D" || this.lookAtType == "ROTATE_2D_CONSTRAINT") {
                let angleZRadians = this.lookAt(lookAtTrack, "z");
                this.mesh.rotation.z = angleZRadians;
            } else if (this.lookAtType == "ROTATE_3D_CONSTRAINT") {
                let xDist = (lookAtTrack.x - this.mesh.position.x) / this.scale;
                let yDist = (lookAtTrack.y - this.mesh.position.y) / this.scale;
                let dist = Math.abs(Math.sqrt(xDist ** 2 + yDist ** 2));

                if (dist > this.size.length) dist = this.size.length;

                let height = Math.abs(Math.sqrt(this.size.length ** 2 - dist ** 2));
                let up = new THREE.Vector3(0, 0, -1);
                let angleYRadians = (Math.PI * .5) - up.angleTo(new THREE.Vector3(xDist, yDist, height));

                if (this.mesh.children && this.mesh.children.length)
                    this.mesh.children[0]!.rotation.y = angleYRadians;

                let angleZRadians = this.lookAt(lookAtTrack, "z");
                this.mesh.rotation.z = angleZRadians;
            }
        }

        this.lastTrack = track;
        this.mesh.updateMatrix();
        this.mesh.updateMatrixWorld(false);
    }
}